import { Controller } from '@hotwired/stimulus'

// Précharge la page d'un lien au moment où il devient VISIBLE, et lui seul.
//
// data-turbo-preload charge dès l'affichage de la page, pour tous les liens
// marqués : sur un téléphone où la grille n'a qu'une colonne, précharger les
// six premières cartes en téléchargeait quatre qu'on ne voyait pas. Ici c'est
// le défilement qui décide — une carte qui entre dans l'écran est une carte
// qu'on peut ouvrir, on la prépare à ce moment-là.
//
// Le travail est confié au préchargeur de Turbo lui-même (Turbo.session
// .preloader) : même requête marquée « prefetch », même cache de snapshots,
// même dédoublonnage — une page déjà en cache n'est jamais redemandée.
//
// Réservé au natif par la vue : sur le web, le survol déclenche déjà le
// prefetch de Turbo, que l'adaptateur Hotwire Native désactive dans l'app.
export default class extends Controller {
  static targets = ['link']

  connect() {
    this.observer = new IntersectionObserver(this.#onIntersect, { threshold: 0.5 })
    this.linkTargets.forEach((link) => this.observer.observe(link))
  }

  disconnect() {
    this.observer?.disconnect()
  }

  // Cartes ajoutées après coup (pagination infinie).
  linkTargetConnected(link) {
    this.observer?.observe(link)
  }

  #onIntersect = (entries) => {
    for (const entry of entries) {
      if (!entry.isIntersecting) continue
      this.observer.unobserve(entry.target)
      window.Turbo?.session?.preloader?.preloadURL(entry.target)
    }
  }
}
